import type { IconProps } from './types';

export function Sapato({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M36 188 Q36 168 56 168 Q120 168 184 168 Q204 168 212 184 Q220 196 220 204 Q220 212 212 212 Q124 216 44 212 Q36 212 36 204 Q36 196 36 188 Z" />
      <path d="M100 168 Q100 148 116 148 Q140 148 140 168" />
    </svg>
  );
}
